export enum StepEnum {
	NameAddressStep,
	ProductStep,
	CprStep,
	MovingInStep,
	CohabitantStep,
	ContactInfoStep,
	BetalingsserviceStep,
	SalesStep,
	SummaryStep,
}
